























import { Component, Mixins } from "vue-property-decorator";
import { Action, Mutation, Getter } from "vuex-class";
import GeneralMixin from "@/mixin";
import { IImage, IImageUpdateRequest } from "@/types/image";
import { ISite } from "@/types/site";
import jspdf from "jspdf";
import html2canvas from "html2canvas";

@Component({
  components: {}
})
export default class extends Mixins<GeneralMixin>(GeneralMixin) {
  @Action("image/adminGetList")
  public getImageList!: (site_id: number) => boolean;
  @Action("site/adminGet")
  public getSite!: (id: number) => void;
  @Getter("site/single")
  public site!: ISite;

  @Getter("image/list")
  public images!: IImage[];
  @Mutation("image/clear")
  public clear!: () => void;

  public site_id = 0;
  public params: IImageUpdateRequest[] = [];

  public async created() {
    this.site_id = Number(this.$route.params.site_id);
    this.clear();

    await Promise.all([
      this.getSite(this.site_id),
      this.getImageList(this.site_id)
    ]);
    setTimeout(this.downloadPDF, 2000);

    this.setDefault();
  }
  //--------
  // 更新時デフォルト値をセットする
  private setDefault() {
    this.images.forEach(image => {
      if (image.is_published) {
        this.params.push({
          url: image.url,
          id: image.id,
          stage_id: image.stage_id,
          memo: image.memo,
          upload_file: "",
          is_published: image.is_published
        });
      }
    });
  }
  public downloadPDF() {
    html2canvas(document.getElementById("report") as HTMLInputElement).then(
      canvas => {
        const pdf = new jspdf("p", "mm", "a4");
        const width = pdf.internal.pageSize.width;
        const dataURI = canvas.toDataURL();
        pdf.addImage(dataURI, "JPEG", 0, 0, width, 0);
        pdf.addPage();
        const canvas_HTMLCollection = document.getElementsByTagName("canvas");
        const canvas_array = Array.prototype.slice.call(canvas_HTMLCollection);
        const canvas_base64_array = canvas_array.map(x => x.toDataURL());
        let i = canvas_base64_array.length - 1;

        for (i; i >= 0; i--) {
          pdf.addImage(canvas_base64_array[i], "JPEG", 0, 0, width, 0);
          pdf.addPage();
        }
        pdf.save("report" + this.site_id + ".pdf");
      }
    );
  }
}
